import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const ProductsService = {
  async getAllProducts(page: number, limit: number) {
    const queryParams = {
      p: page,
      l: limit,
    };

    let response = await $axios
      .get($api("products", queryParams))
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getSearchData(value: string) {
    let response = await $axios
      .get($api("products_search", { value }))
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addProduct(payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("products_add_edit"),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
  async updateProduct(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("products_add_edit_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
  async deleteProduct(id: string) {
    let { data, status } = await $axios
      .delete($api("products_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};
